<template>
	<div class="md-layout upload-group">
		<div class="md-layout-item">
			<md-card>
				<md-card-header class="md-card-header-icon text_center">
					<h3>{{ $t("seller.upload.excel.title") }}</h3>
				</md-card-header>
				<md-card-content>
					<div class="flex flex_column flex_between">
						<div class="card_content_head">
							<div class="xml_excel_upload">
								<h4 class="text_center">{{ $t("seller.upload.excel.step1.title") }}</h4>
								<div class="icon_tip" style="margin-left:15px; margin-top:0; height:180px">
									<AssignmentTypeSelect
										v-model="form.disclosed"
										:required="true"
									></AssignmentTypeSelect>
									<RetentionCheck
										v-model="form.sellWithRetention"
										:debtor-id="null"
										:validation-rules="modelValidations.sellWithRetention"
										:validator="$validator"
										:is-multiple="true"
									/>
									<NoSanctionsCheck
										v-model="form.noSanctionsConfirmation"
										:validation-rules="modelValidations.noSanctionsConfirmation"
										:validator="$validator"
										:is-multiple="true"
									/>
								</div>

								<div v-if="excelUploadPossible">
									<h4 class="text_center font_bold" style="margin-top: 20px;">
										{{ $t("seller.upload.excel.step2.title") }}
										<a class="font_base font_weight_normal" :href="excelUrl" target="_blank">
											({{ $t("common.template") }})
										</a>
									</h4>

									<div>
										<FileInputUpload
											v-on:isUploaded="onUploadSuccess"
											:is-disclosed="form.disclosed"
										></FileInputUpload>
										<div style="margin-top: 15px; margin-left: 15px;"/>

									</div>
								</div>
							</div>
						</div>

						<div  v-if="excelUploadPossible">
							<h3 v-if="videoUploadPercent == 0" class="inactive_color"></h3>
							<h3 class="accent_color" v-if="videoUploadPercent > 0">
								{{ $t("seller.upload.cardlist.Uploading") }}
								{{ videoUploadPercent + "%" }}
								{{ $t("seller.upload.cardlist.Documents") }}
							</h3>

							<div v-if="isUploaded">
								<h4 class="text_center font_bold" style="margin-top: 20px;">
									{{ $t("seller.upload.excel.step3.title") }}</h4>
								<div style="margin:1rem" @click="changeItem(item)">
									<FileUpload
										v-on:chageFile="chageFile"
										:filUrl="form.url"
										v-on:changePercent="changePercent"
										:disable="isLoading"
										:iconName="iconName"
										:accept="accept"
										:loadApi="'uploadDocuments'"
									></FileUpload>
								</div>
								<p class="paf_tip text_center">{{ $t("seller.upload.excel.files.tip") }}</p>
							</div>
						</div>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>
</template>
<script>
import FileUpload from "src/components/templates/FileUpload.vue";
import FileInputUpload from "./FileInputUpload.vue";
import enumStatus from "src/common/enum";
import APP from "src/common/appConfig";
import {localization} from "src/common/lang/localization";
import AssignmentTypeSelect from "@/components/templates/select/AssignmentTypeSelect.vue";
import RetentionCheck from "./RetentionCheck.vue";
import {validateRequiredFields} from "@/validation/validation";
import NoSanctionsCheck from "@/components/templates/seller/NoSanctionsCheck.vue";

export default {
	components: {
		NoSanctionsCheck,
		AssignmentTypeSelect,
		FileUpload,
		FileInputUpload,
		RetentionCheck
	},
	data() {
		let defaultForm = {
			url: "",
			disclosed: this.$sessionStorage.get("localeUser").auctionDisclosed,
			noSanctionsConfirmation: false,
			sellWithRetention: false
		};
		return {
			form: { ...defaultForm },
			upTypeList: [],
			activeItem: {},
			videoUploadPercent: 0,
			isLoading: false,
			accept: "pdf",
			iconName: "fa-file-text",
			excelUrl: `${APP.DOMAIN}static/xls/Walbing-import-${localization.currentLocale()}-7.0.xlsx`,
			isUploaded: false,
			modelValidations: {
				noSanctionsConfirmation: {
					checked: true
				},
				sellWithRetention: {
					checked: true
				},
				disclosed: {
					required: true
				}
			},
		};
	},
	mounted() {
		this.upTypeList = enumStatus.upTypeList;
	},
	methods: {
		onUploadSuccess(successful) {
			this.isUploaded = successful;
		},
		chageFile(data) {
		},

		changePercent(data) {
			this.isLoading = true;
			this.videoUploadPercent = data.uploadPercent;
			if (data.uploadPercent >= 100) {
				setTimeout(() => {
					this.$emit("uploaded");
					this.videoUploadPercent = 0;
					this.isLoading = false;
				}, 500);
			}
		},
	},
	computed: {
		excelUploadPossible() {
			return validateRequiredFields(this.form, this.modelValidations);
		}
	}
};
</script>
<style lang="scss" scoped>
@import "./upload.scss";
</style>
